<template>
  <div class="menu-page">
    <Nav
      :title="title"
      :chips="navHeaders"
    />
    <div>
      <Section
        v-for="section in guidesChapters"
        :key="section.slug"
        :section="section"
      />
    </div>
  </div>
  <SubscriptionBlock
    :analytics-api-url="VITE_RUNTIME_SOGU_SERVICE_URL"
    class="subscription-block"
  />
</template>

<script setup lang="ts">
  import { useGuidesStore } from '@/entities/guides/store/useGuidesStore';
  import Nav, { type IChip } from '@/widgets/Nav.vue';
  import Section from '@/widgets/Section.vue';
  import { SubscriptionBlock } from '@experience/subscription-block-package';
  import { useRuntimeConfig } from 'virtual:runtime-config';
  import { useHead } from '@unhead/vue';

  const title = 'Помощь гидам';

  useHead({
    title: `${title} — Tripster`,
  });

  const guidesStore = useGuidesStore();
  const { guidesChapters } = storeToRefs(guidesStore);
  const { VITE_RUNTIME_SOGU_SERVICE_URL } = useRuntimeConfig<false>();

  const navHeaders = computed<IChip[]>(
    () =>
      guidesChapters.value?.map((chapter) => ({
        name: chapter.title,
        link: chapter.slug,
      })) || [],
  );
  guidesStore.getGuideChapters();
</script>

<style scoped lang="scss">
  .menu-page {
    max-width: 805px;
    margin: 0 auto;
    padding: 0 20px;
  }
</style>
